import { useAuth } from '@/contexts/AuthContext';
import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { useState } from 'react';

export function ExportButton({ module, params = {}, label = "Export Excel" }) {
  const { api } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => { if (v) queryParams.set(k, v); });
      const res = await api.get(`/export/${module}?${queryParams.toString()}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `keya_pulse_${module}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Export downloaded');
    } catch (err) {
      toast.error('Export failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button variant="outline" size="sm" onClick={handleExport} disabled={loading} data-testid={`export-${module}-btn`} className="h-9 gap-2 text-xs font-medium">
      {loading ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} strokeWidth={1.5} />}
      {label}
    </Button>
  );
}
